<div class="spinner_overlay"></div>
<div class="spinner">
  <div class="rect rect1"></div>
  <div class="rect rect2"></div>
  <div class="rect rect3"></div>
  <div class="rect rect4"></div>
  <div class="rect rect5"></div>
</div>
